define('views/modules/calendar/animated-session/exercise/weight/week-brief/weight-brief-week',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // views
    'views/modules/calendar/animated-session/exercise/weight/weight-week',
    'views/modules/calendar/animated-session/exercise/weight/week-brief/weight-brief-set',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // views
    VWeightExerciseWeek,
    VWeightBriefSet
) {

    var VWeightBriefWeek = VWeightExerciseWeek.extend({
        exerciseSetView: VWeightBriefSet
    });

    return VWeightBriefWeek;

});

